import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ErrorMessage, Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { BsPatchPlus } from "react-icons/bs";
import { FcDataConfiguration } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { MaterialPlanningSchema } from "../../../Schemas/Material Planning/material_planning.schema";
import { SoftMaterialPlanningSchema } from "../../../Schemas/Material Planning/soft_material.schema";
import { toBeProducedSchema } from "../../../Schemas/Material Planning/tobe_produced.schema";

const EditMaterial = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [MaterialPlaningInfo, setMaterialPlaningInfo] = useState({});
  const [SoftMaterialPlanningInfo, setSoftMaterialPlaningInfo] = useState({});
  const [ToBeProducedInfo, setToBeProducedMaterialPlaningInfo] = useState({});

  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/newMaterialModel/getMaterialModelByID/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          if (res.data?.newMaterialPlaning) {
            setMaterialPlaningInfo(res.data?.newMaterialPlaning);
          }
          if (res.data?.newSoftMaterial) {
            setSoftMaterialPlaningInfo(res.data?.newSoftMaterial);
          }
          if (res.data?.newToBeProduced) {
            setToBeProducedMaterialPlaningInfo(res.data?.newToBeProduced);
          }
        } else {
          Toast("error", "Error while Material Planning Details!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  const handleSubmitMaterialPlanning = (values, actions) => {
    if (!data?.bay) {
      alert("Bay size not available");
    } else if (!data?.span) {
      alert("Span size not available");
    } else if (!data?.materialPlanningId) {
      alert("Material plan id not available");
    } else {
      values = {
        ...values,
        bay: data?.bay,
        span: data?.span,
        systemType: data?.systemType,
      };

      performRequest(
        "PATCH",
        `/newMaterialModel/updateMaterialPlanning/${data?.materialPlanningId}`,
        values
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Material Planning updated successfully!");
            // navigate(`/material-planning`);
          } else {
            Toast("error", "Error while Creating");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };
  const handleSubmitToBePlanning = (values, actions) => {
    if (!data?.bay) {
      alert("Bay size not available");
    } else if (!data?.span) {
      alert("Span size not available");
    } else if (!data?.toBeProducedId) {
      alert("To be produced id not available");
    } else {
      values = {
        ...values,
        bay: data?.bay,
        span: data?.span,
        systemType: data?.systemType,
      };
      // setLoading(true);

      performRequest(
        "PATCH",
        `/newMaterialModel/updateTobeProduced/${data?.toBeProducedId}`,
        values
      )
        .then((res) => {
          if (res.status === 200) {
            Toast(
              "success",
              "To Be Produced Material Planning updated successfully!"
            );
          } else {
            Toast("error", "Error while Updating");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };
  const handleSubmitSoftMaterialPlanning = (values, actions) => {
    const formData = new FormData();
    for (let key in values) {
      let newObj = values[key];
      if (
        key !== "pollyhouseDesign1" &&
        key !== "pollyhouseDesign2" &&
        newObj &&
        typeof newObj === "object"
      ) {
        for (let subkey in newObj) {
          formData.append(`${key}.${subkey}`, newObj[subkey]);
        }
      } else {
        formData.append(key, values[key]);
      }
    }
    if (!data?.bay) {
      alert("Bay size not available");
    } else if (!data?.span) {
      alert("Span size not available");
    } else if (!data?.softMaterialId) {
      alert("Soft material plan id not available");
    } else {
      formData.append("bay", data?.bay);
      formData.append("span", data?.span);
      formData.append("systemType", data?.systemType);
      const headers = { "Content-Type": "multipart/form-data" };

      performRequest(
        "PATCH",
        `/newMaterialModel/updateSoftMaterial/${data?.softMaterialId}`,
        formData,
        headers
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Soft Material Planning updated successfully!");
            // navigate(`/material-planning`);
          } else {
            Toast("error", "Error while update");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  const handelPolyhouseDesignUpdate = (values, actions) => {
    const formData = new FormData();
    if (!data?.bay) {
      alert("Bay size not available");
    } else if (!data?.span) {
      alert("Span size not available");
    } else if (!data?.softMaterialId) {
      alert("Soft material plan id not available");
    } else {
      formData.append("bay", data?.bay);
      formData.append("span", data?.span);
      formData.append("systemType", data?.systemType);
      formData.append("pollyhouseDesign1", values?.pollyhouseDesign1);
      formData.append("pollyhouseDesign2", values?.pollyhouseDesign2);
      const headers = { "Content-Type": "multipart/form-data" };

      performRequest(
        "PATCH",
        `/newMaterialModel/updateSoftMaterial/${data?.softMaterialId}`,
        formData,
        headers
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Polyhouse Designs updated successfully!");
            // navigate(`/material-planning`);
          } else {
            Toast("error", "Error while update");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcDataConfiguration className="fs-2  me-1" /> Edit Material
                  Plan {`(${data?.bay} * ${data?.span})`}
                </h2>
                <h4 className="text-muted">
                  {data?.systemType
                    ? `${data?.systemType}`
                    : `Allot & update new material list.`}
                </h4>
              </div>
              <div className="col-md-4">
                {/* <div className="btn-list justify-content-end">
                  <a href={"/task-management"}>
                    <button className="btn btn-primary">
                      <BsPatchPlus className="me-2 fs-2" /> View Task List
                    </button>
                  </a>
                </div> */}
                <div className="btn-list justify-content-end">
                  <a href={"/material-planning"}>
                    <button className="btn btn-primary">
                      <BsPatchPlus className="me-2 fs-2" />VIEW MATERIAL PLAN LIST
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 py-2">
              <div className="card">
                <Formik
                  initialValues={MaterialPlaningInfo}
                  validationSchema={MaterialPlanningSchema}
                  onSubmit={handleSubmitMaterialPlanning}
                >
                  {(props) => (
                    <Form>
                      <div className="table-responsive">
                        <table className="table table-vcenter">
                          <thead>
                            <tr>
                              <th>Sr</th>
                              <th>item Name</th>
                              <th></th>
                              <th>diameter (mm)</th>
                              <th>length (mm)</th>
                              <th>quantity</th>
                              <th>quantityUnit</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(MaterialPlaningInfo).map(
                              (key, index) => {
                                const item = MaterialPlaningInfo[key];

                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td colSpan={2}>{item.itemName}</td>
                                    <td>{item.diameterInMM}</td>
                                    <td>{item.lengthInMeters}</td>
                                    <td>
                                      <CustomInput
                                        name={`${key}.quantity`}
                                        type="text"
                                      />
                                      <ErrorMessage
                                        name={`${key}.quantity`}
                                        component="div"
                                        className="text-danger"
                                      />
                                    </td>

                                    <td>
                                      <CustomSelect
                                        type="text"
                                        name={`${key}.quantityUnit`}
                                      >
                                        <option value="">Select</option>
                                        <option value="nos">Nos</option>
                                        <option value="kg">Kg</option>
                                        <option value="grams">Grams</option>
                                        <option value="ltr">Litter</option>
                                        <option value="ml">ML</option>
                                        <option value="packs">Packs</option>
                                        <option value="pair">Pair</option>
                                        <option value="sqm">SqM</option>
                                        <option value="sqft">SqFt</option>
                                        <option value="mts">Meters</option>
                                        <option value="pcs">Pices</option>
                                      </CustomSelect>

                                      <ErrorMessage
                                        name={`${key}.quantityUnit`}
                                        component="div"
                                        className="text-danger"
                                      />
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Update Material plan" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
              <hr />
              <h3>Soft Material:</h3>
              <hr />
              <div className="card">
                <Formik
                  initialValues={SoftMaterialPlanningInfo}
                  validationSchema={SoftMaterialPlanningSchema}
                  onSubmit={handleSubmitSoftMaterialPlanning}
                >
                  {(props) => (
                    <Form>
                      <div className="table-responsive">
                        <table className="table table-vcenter">
                          <thead>
                            <tr>
                              <th>Sr</th>
                              <th>item Name</th>
                              <th></th>
                              <th>width (m)</th>
                              <th>length (mm)</th>
                              <th>quantity</th>
                              <th>quantityUnit</th>
                              <th>perQuantityArea</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(SoftMaterialPlanningInfo).map(
                              (key, index) => {
                                const item = SoftMaterialPlanningInfo[key];
                                if (
                                  key !== "pollyhouseDesign1" &&
                                  key !== "pollyhouseDesign2"
                                ) {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td colSpan={2}>{item.itemName}</td>
                                      <td>{item.width}</td>
                                      <td>
                                        <CustomInput
                                          name={`${key}.length`}
                                          type="text"
                                        />
                                        <ErrorMessage
                                          name={`${key}.length`}
                                          component="div"
                                          className="text-danger"
                                        />
                                      </td>
                                      <td>
                                        <CustomInput
                                          name={`${key}.quantity`}
                                          type="text"
                                        />
                                        <ErrorMessage
                                          name={`${key}.quantity`}
                                          component="div"
                                          className="text-danger"
                                        />
                                      </td>
                                      <td>
                                        <CustomSelect
                                          type="text"
                                          name={`${key}.quantityUnit`}
                                        >
                                          <option value="">Select</option>
                                          <option value="nos">Nos</option>
                                          <option value="kg">Kg</option>
                                          <option value="grams">Grams</option>
                                          <option value="ltr">Litter</option>
                                          <option value="ml">ML</option>
                                          <option value="packs">Packs</option>
                                          <option value="pair">Pair</option>
                                          <option value="sqm">SqM</option>
                                          <option value="sqft">SqFt</option>
                                          <option value="mts">Meters</option>
                                          <option value="pcs">Pices</option>
                                        </CustomSelect>

                                        <ErrorMessage
                                          name={`${key}.quantityUnit`}
                                          component="div"
                                          className="text-danger"
                                        />
                                      </td>
                                      <td>
                                        <CustomInput
                                          name={`${key}.perQuantityArea`}
                                          type="text"
                                        />
                                        <ErrorMessage
                                          name={`${key}.perQuantityArea`}
                                          component="div"
                                          className="text-danger"
                                        />
                                      </td>
                                    </tr>
                                  );
                                } else {
                                  return;
                                }
                              }
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Update Soft Material plan" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
              <hr />
              <h3>Polyhouse Design</h3>
              <hr />
              <div className="card">
                <Formik
                  initialValues={SoftMaterialPlanningInfo}
                  validationSchema={SoftMaterialPlanningSchema}
                  onSubmit={handelPolyhouseDesignUpdate}
                >
                  {(props) => (
                    <Form>
                      <div className="my-3 row mx-2">
                        <label className="w-25 form-label col-3 ">
                          Top View :
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            name="pollyhouseDesign1"
                            onChange={(e) =>
                              props.setFieldValue(
                                "pollyhouseDesign1",
                                e.target.files[0]
                              )
                            }
                            type="file"
                          />
                          {props.touched.pollyhouseDesign1 &&
                            props.errors.pollyhouseDesign1 && (
                              <p className="text-danger">
                                {props.errors.pollyhouseDesign1}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row mx-2">
                        <label className="w-25 form-label col-3 ">
                          Isometric View :
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            name="pollyhouseDesign2"
                            onChange={(e) =>
                              props.setFieldValue(
                                "pollyhouseDesign2",
                                e.target.files[0]
                              )
                            }
                            type="file"
                          />
                          {props.touched.pollyhouseDesign2 &&
                            props.errors.pollyhouseDesign2 && (
                              <p className="text-danger">
                                {props.errors.pollyhouseDesign2}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Update Polyhouse Designs" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
              <hr />
              <h3>To Be Produce:</h3>
              <hr />
              <div className="card">
                <Formik
                  initialValues={ToBeProducedInfo}
                  validationSchema={toBeProducedSchema}
                  onSubmit={handleSubmitToBePlanning}
                >
                  {(props) => (
                    <Form>
                      <div className="table-responsive">
                        <table className="table table-vcenter">
                          <thead>
                            <tr>
                              <th>Sr</th>
                              <th>Size</th>
                              <th></th>
                              <th>3 mm</th>
                              <th>2.9 mm</th>
                              <th>2.6 mm</th>
                              <th>2 mm</th>
                              <th>1.8 mm</th>
                              <th>1.6 mm</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(ToBeProducedInfo).map((key, index) => {
                              const item = ToBeProducedInfo[key];
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td colSpan={2}>{item.itemName}</td>

                                  <td>
                                    <CustomInput
                                      name={`${key}.s3mm`}
                                      type="text"
                                    />
                                    <ErrorMessage
                                      name={`${key}.s3mm`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>
                                  <td>
                                    <CustomInput
                                      name={`${key}.s2p9mm`}
                                      type="text"
                                    />
                                    <ErrorMessage
                                      name={`${key}.s2p9mm`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>
                                  <td>
                                    <CustomInput
                                      name={`${key}.s2p6mm`}
                                      type="text"
                                    />
                                    <ErrorMessage
                                      name={`${key}.s2p6mm`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>
                                  <td>
                                    <CustomInput
                                      name={`${key}.s2mm`}
                                      type="text"
                                    />
                                    <ErrorMessage
                                      name={`${key}.s2mm`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>
                                  <td>
                                    <CustomInput
                                      name={`${key}.s1p8mm`}
                                      type="text"
                                    />
                                    <ErrorMessage
                                      name={`${key}.s1p8mm`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>
                                  <td>
                                    <CustomInput
                                      name={`${key}.s1p6mm`}
                                      type="text"
                                    />
                                    <ErrorMessage
                                      name={`${key}.s1p6mm`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Update To Be Produced Material plan" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditMaterial;
